module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/SPG-tiny.84beaddc.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/SPG-tiny.png
// module id = 2715
// module chunks = 11